// pages/Admin.js - Main admin dashboard with sidebar
import React, { useState } from 'react';
import { Flag, Users, BarChart3, Settings, Menu, X, MessageSquare } from 'lucide-react';
import AdminReports from './AdminReports';
import AdminComments from './AdminComments';

function Admin() {
  const [activeTab, setActiveTab] = useState('reports');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const menuItems = [
    {
      id: 'reports',
      label: 'Wrong Info Reports',
      icon: Flag,
      component: AdminReports
    },
    {
      id: 'comments',
      label: 'Comment Management',
      icon: MessageSquare,
      component: AdminComments
    },
    {
      id: 'users',
      label: 'Users',
      icon: Users,
      component: () => <div className="p-8 text-center text-gray-500">Users management coming soon...</div>
    },
    {
      id: 'analytics',
      label: 'Analytics',
      icon: BarChart3,
      component: () => <div className="p-8 text-center text-gray-500">Analytics coming soon...</div>
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: Settings,
      component: () => <div className="p-8 text-center text-gray-500">Settings coming soon...</div>
    }
  ];

  const ActiveComponent = menuItems.find(item => item.id === activeTab)?.component || AdminReports;

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200">
          <h2 className="text-xl font-bold text-gray-900">Admin Panel</h2>
          <button
            onClick={() => setSidebarOpen(false)}
            className="lg:hidden text-gray-500 hover:text-gray-700"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <nav className="mt-6">
          {menuItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <button
                key={item.id}
                onClick={() => {
                  setActiveTab(item.id);
                  setSidebarOpen(false);
                }}
                className={`
                  w-full flex items-center px-6 py-3 text-left text-sm font-medium transition-colors
                  ${activeTab === item.id
                    ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }
                `}
              >
                <IconComponent className="w-5 h-5 mr-3" />
                {item.label}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Mobile header */}
        <div className="lg:hidden bg-white shadow-sm border-b border-gray-200 px-4 py-3">
          <div className="flex items-center justify-between">
            <button
              onClick={() => setSidebarOpen(true)}
              className="text-gray-500 hover:text-gray-700"
            >
              <Menu className="w-6 h-6" />
            </button>
            <h1 className="text-lg font-semibold text-gray-900">Admin Panel</h1>
            <div className="w-6" /> {/* Spacer */}
          </div>
        </div>

        {/* Content area */}
        <div className="flex-1 overflow-auto">
          <ActiveComponent />
        </div>
      </div>
    </div>
  );
}

export default Admin;